import React from 'react';
import '../../styles/about/moon.css';

interface MoonData {
  name: string;
  orbitRadius: number;
  size: number;
  speed: number;
}

interface MoonProps {
  moon: MoonData;
  index: number;
  planetColor: string;
  isVisible: boolean;
  isSoloFocus?: boolean;
  onHover?: (moonName: string) => void;
  onLeave?: () => void;
  onClick?: (moonName: string) => void;
}

const Moon: React.FC<MoonProps> = ({ 
  moon, 
  index, 
  planetColor, 
  isVisible, 
  isSoloFocus = false,
  onHover, 
  onLeave, 
  onClick 
}) => {
  const orbitDuration = `${moon.speed * 5}s`;
  // Much larger orbits for floating moons to ensure they appear outside the planet
  const orbitSize = isSoloFocus ? moon.orbitRadius * 150 : moon.orbitRadius * 40;
  const moonSize = isSoloFocus ? moon.size * 50 : moon.size * 30;

  const moonStyle = {
    '--orbit-duration': orbitDuration,
    '--moon-size': `${moonSize}px`,
    '--moon-delay': `${index * 0.2}s`, // Longer delays for staggered appearance
    '--moon-color': planetColor,
    '--orbit-size': `${orbitSize}px`
  } as React.CSSProperties;

  const handleClick = () => {
    if (onClick) {
      onClick(moon.name);
    }
  };

  const handleMouseEnter = () => {
    if (onHover) {
      onHover(moon.name);
    }
  };

  const handleMouseLeave = () => {
    if (onLeave) {
      onLeave();
    }
  };

  return (
    <div
      className={`moon-orbit ${isVisible ? 'moon-orbit--visible' : ''} ${isSoloFocus ? 'moon-orbit--floating' : ''}`}
      style={{
        width: orbitSize,
        height: orbitSize,
        ...moonStyle
      }}
    >
      <div
        className={`moon ${isVisible ? 'moon--visible' : ''} moon--interactive ${isSoloFocus ? 'moon--floating' : ''}`}
        style={moonStyle}
        data-name={moon.name}
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        role="button"
        tabIndex={0}
        aria-label={`Technology: ${moon.name}`}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
          }
        }}
      >
        {/* Moon Surface */}
        <div className="moon__surface">
          {/* Moon Crater Pattern */}
          <div className="moon__craters"></div>
          
          {/* Technology Icon/Initial */}
          <div className="moon__tech-indicator">
            {moon.name.charAt(0).toUpperCase()}
          </div>
        </div>

        {/* Moon Glow */}
        <div className="moon__glow"></div>

        {/* Technology Label - Always visible when in solo focus mode */}
        <div className={`moon__label ${isSoloFocus ? 'moon__label--always-visible' : ''}`}>
          <span className="moon__name">{moon.name}</span>
        </div>
      </div>
    </div>
  );
};

export default Moon; 